import _Abstract from "system/abstract"

export default class Component_SocialNetworksPopup extends _Abstract {

  constructor(el, options)
  {
    super(el, $.extend(true, {
    }, options), 'component')
    this.bindEvents()
  }
  

    bindEvents()
    {
      this.$el.click((e) => this.onTriggerElementClicked(e));
    }


    onTriggerElementClicked(e)
    {
      console.log("onTriggerElementClicked");
    }

}



/** WEBPACK FOOTER **
 ** ./components/social-networks-popup.js
 **/